import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { SharedService } from './sharedService';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DropdownService{

  constructor(public http: HttpClient, public sharedService: SharedService) { 

  }

  getLocations(resourceUrl:string): Observable<any> {
    return this.http.get(this.sharedService.apiUrl(resourceUrl)).pipe(
      map(res => {
        return res;
      })
    );
  }

  getList(resourceUrl:string): Observable<any> {
    return this.http.get(this.sharedService.apiUrl(resourceUrl)).pipe(
      catchError(error => {
        return throwError(error);
      }), 
      map(res => {
        return res;
      })
    );
  }
 
}



